(function () {
    'use strict';

    function rfpResponse(requestForProposalResponseStateService) {
        return {
            restrict: 'E',
            templateUrl: 'requestForProposal/directives/templates/rfpResponse.html',
            scope: {
                rfpResponseData: '=',
                mode: '@'
            },
            link: function (scope, element, attrs) {
                if (!attrs.mode) {
                    scope.mode = 'Editor';
                }

                scope.rfpResponseReorderMode = false;

                scope.removeInformationPart = function (informationPart, partIndex) {
                    requestForProposalResponseStateService.removeInformationPartFromRfpContent(informationPart, partIndex);
                }

                scope.deleteUpload = function (informationPart, blobIndex) {
                    requestForProposalResponseStateService.deleteUpload(informationPart, blobIndex);
                }

                scope.updateDocumentPrompt = function (document) {
                    requestForProposalResponseStateService.updateDocumentPrompt(document);
                }

                scope.syncQuestionSet = function (informationPart, partIndex) {
                    requestForProposalResponseStateService.syncQuestionSet(informationPart, partIndex);
                }

                scope.rfpResponseData.ResponseContent.InformationParts.forEach(function (informationPart) {
                    if (!scope.rfpResponseData.hasPermissionsSet) {
                        informationPart.canDelete = scope.mode === 'Editor';
                        informationPart.reorderMode = false;
                        informationPart.Access = {
                            View: true,
                            Edit: false
                        }

                        if (informationPart.BlobSummaries) {
                            informationPart.BlobSummaries.forEach(function (blob) {
                                blob.Access = {
                                    View: true,
                                    Edit: true
                                };
                                blob.UploadedByCleanName = blob.UploadedByEntity
                                    ? blob.UploadedByEntity.Contact.FirstName + ' ' + blob.UploadedByEntity.Contact.LastName
                                    : 'N/A';
                            });
                        }
                    }
                });
            }
        };
    }

    rfpResponse.$inject = ['requestForProposalResponseStateService'];

    angular.module('ecap.requestForProposal').directive('rfpResponse', rfpResponse);
})();

